import React from "react";
import { Col, Select } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { range } from "lodash";

const CalendarHeader = ({ value, type, onChange, onTypeChange }) => {
    const monthOptions = [];

    const current = value.clone();
    const localeData = value.localeData();
    const months = [];
    range(0, 12).forEach(index => {
        current.month(index);
        months.push(localeData.monthsShort(current));
    });

    range(0, 12).forEach(index => {
        monthOptions.push(
            <Select.Option className="month-item" key={`${index}`}>
                {months[index]}
            </Select.Option>,
        );
    });
    const month = value.month();

    const year = value.year();
    const options = [];
    for (let i = year - 10; i < year + 10; i += 1) {
        options.push(
            <Select.Option
                key={i}
                value={i}
                className="year-item"
            >
                {i}
            </Select.Option>,
        );
    }
    return (
        <div className="d-flex justify-content-between p-2">
            <div className="mr-2 d-inline-flex align-items-center">
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                        const newValue = value.clone();
                        newValue.subtract(1, "months");
                        onChange(newValue);
                    }}
                >
                    <FontAwesomeIcon icon="arrow-circle-left"/>
                </button>
            </div>
            <div className="mx-2 d-inline-flex">
                <Col>
                    <Select
                        size="small"
                        dropdownMatchSelectWidth={false}
                        className="my-year-select"
                        onChange={newYear => {
                            const now = value.clone()
                                .year(newYear);
                            onChange(now);
                        }}
                        value={String(year)}
                    >
                        {options}
                    </Select>
                </Col>
                <Col>
                    <Select
                        size="small"
                        dropdownMatchSelectWidth={false}
                        value={String(month)}
                        onChange={selectedMonth => {
                            const newValue = value.clone();
                            newValue.month(parseInt(selectedMonth, 10));
                            onChange(newValue);
                        }}
                    >
                        {monthOptions}
                    </Select>
                </Col>
            </div>
            <div className="ml-2 d-inline-flex align-items-center">
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                        const newValue = value.clone();
                        newValue.add(1, "months");
                        onChange(newValue);
                    }}
                >
                    <FontAwesomeIcon icon="arrow-circle-right"/>
                </button>
            </div>
        </div>
    );
};

export default CalendarHeader;
